import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Home, Layers, Plus, User, Users } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { useLang } from "@/i18n/LanguageContext";

/** Mobile bottom navigation for the authenticated app: Home · Ideas · + · Explore · Profile. */
export function AppNav() {
  const { user } = useAuth();
  const { t } = useLang();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  if (!user) return null;
  const item = (testid, Icon, label, to, active) => (
    <button key={testid} data-testid={testid} onClick={() => navigate(to)} className={`flex flex-col items-center gap-0.5 text-[10px] font-semibold tracking-wide min-h-[44px] justify-end ${active ? "text-white" : "text-slate-400"}`}>
      <Icon size={20} strokeWidth={active ? 2.4 : 1.8} /> {label}
    </button>
  );
  return (
    <>
    <nav className="md:hidden fixed bottom-0 inset-x-0 z-40 cpenz-glass-dark border-t border-white/10 px-6 pb-[max(env(safe-area-inset-bottom),10px)] pt-2 grid grid-cols-5 items-end" data-testid="app-nav" aria-label="App">
      {item("appnav-home", Home, t("appnav.home"), "/app/home", pathname === "/app/home")}
      {item("appnav-ideas", Layers, t("appnav.ideas"), "/app/dashboard", pathname.startsWith("/app/dashboard") || pathname.startsWith("/app/project"))}
      <button data-testid="appnav-new" aria-label={t("appnav.ideas")} onClick={() => navigate("/app/home")} className="flex flex-col items-center -mt-5">
        <span className="w-12 h-12 rounded-full bg-white text-[#0b0f1a] inline-flex items-center justify-center shadow-[0_12px_30px_-10px_rgba(255,255,255,0.35)]"><Plus size={22} /></span>
      </button>
      {item("appnav-community", Users, "Community", "/community", pathname.startsWith("/community") || pathname.startsWith("/market"))}
      {item("appnav-profile", User, t("appnav.profile"), "/app/profile", pathname === "/app/profile")}
    </nav>
    </>
  );
}
